import type { SwitchOption } from '@/features/dashboard/config';
import { ReportOptions } from '@/features/dashboard/components/ReportOptions';
import type { MorrisonsPayload } from '../report';
import { fmtPeriod } from '../format';

type Props = {
  campaign: MorrisonsPayload['campaign'];
  isPreview: boolean;
  /** "14:05:12", or null when the report has never been refreshed. */
  updatedAt: string | null;
  onExport: () => void;
  switchOptions: SwitchOption[];
  onSwitch: (path: string) => void;
  isAdmin: boolean;
  onManageUsers: () => void;
  onSignOut: () => void;
};

/** The design's green band: brand badge, title, live state, period, export, report switcher and account actions. */
export function Header(props: Props) {
  const { campaign } = props;
  const state = campaign.live ? 'Live' : campaign.currentWeek === 0 ? 'Not started' : 'Ended';
  return (
    <header className="mo-band">
      <div className="mo-wrap">
        <div className="mo-id">
          <div className="mo-badge" aria-hidden="true">
            Morrisons
            <br />× Disney
          </div>
          <div>
            <h1>Morrisons — Disney × Stickers 2026</h1>
            <p>Campaign dashboard</p>
          </div>
        </div>
        <div className="mo-ctrl">
          {props.isPreview && <span className="mo-chip mo-chip-warn">No live data</span>}
          <span className="mo-chip">
            <span className={`mo-dot${campaign.live ? ' on' : ''}`} />
            <b>{state}</b>
            {props.updatedAt && <span className="mo-chip-sub">· updated at {props.updatedAt}</span>}
          </span>
          <span className="mo-chip">
            Period <b>{fmtPeriod(campaign.start, campaign.end)}</b>
          </span>
          <button type="button" className="mo-btn mo-btn-hot" onClick={props.onExport}>
            Export
          </button>
          {/* `switchOptions` already excludes this report, so one option is a real destination. */}
          {props.switchOptions.length > 0 && (
            <select className="mo-switch" value="" aria-label="Switch report" onChange={(e) => e.target.value && props.onSwitch(e.target.value)}>
              <option value="">Report…</option>
              <ReportOptions options={props.switchOptions} labels={{ active: 'Active', archived: 'Archived' }} />
            </select>
          )}
          {props.isAdmin && (
            <button type="button" className="mo-btn" onClick={props.onManageUsers}>
              Users
            </button>
          )}
          <button type="button" className="mo-btn" onClick={props.onSignOut}>
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
